import React from "react";
import { ArrowRight } from "lucide-react";
import { safeLocaleString } from '../../../../utils/format';

const SegmentBar = ({ config, count, totalCount, isActive, onClick }) => {
  const percentage = totalCount > 0 ? (count / totalCount) * 100 : 0;

  return (
    <div
      onClick={() => onClick(config)}
      className={`group cursor-pointer p-5 rounded-xl border transition-all relative overflow-hidden ${
        isActive ? "bg-slate-50 border-blue-500 shadow-md" : "bg-white border-slate-100 hover:border-blue-300"
      }`}
    >
      <div className="flex justify-between items-center mb-3 relative z-10">
        <div className="flex items-center gap-3">
          <span className={`w-3 h-3 rounded-full ${config.color}`}></span>
          <h4 className="font-bold text-lg text-slate-800">{config.label}</h4>
          <span className="text-xs bg-slate-100 px-2 py-0.5 rounded text-slate-500">
            {`${config.range}/ngày`}
          </span>
        </div>
        <ArrowRight
          size={18}
          className={`text-blue-500 transition-opacity ${
            isActive ? "opacity-100" : "opacity-0 group-hover:opacity-100"
          }`}
        />
      </div>

      <div className="mb-4 relative z-10">
        <div>
          <p className="text-xs text-slate-500 mb-1">Số lượng Merchant</p>
          <p className="font-bold text-2xl text-slate-900">{safeLocaleString(count)}</p>
        </div>
      </div>

      <div className="relative w-full h-2 bg-slate-100 rounded-full overflow-hidden">
        <div
          className={`absolute top-0 left-0 h-full rounded-full ${config.color.replace(
            "bg-",
            "bg-opacity-80 bg-"
          )}`}
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      <p className="text-xs text-slate-400 mt-2 text-right relative z-10">
        Chiếm {percentage.toFixed(1)}% tổng số lượng
      </p>
    </div>
  );
};

export default SegmentBar;